import { HexColorPicker } from "react-colorful";
import { useRef } from "react";
import { useClickOutside } from "../../utils";
import "./Colorpicker.scss";

type Props = {
    color: string,
    onChange: React.Dispatch<React.SetStateAction<string>>,
    setDefault: () => void,
    onClose: () => void,
    bgColor: string,
    textColor: string,
}
const presetColors = ["#000000", "#0000FF", "#00FF00", "#FFFF00", "#FF0000"];

export const SwatchesPicker = ({ color, onChange, onClose, setDefault, bgColor, textColor }: Props) => {
    const colorPickerRef = useRef<HTMLDivElement>(null)

    useClickOutside(colorPickerRef, () => {
        onClose();
    });

    return (
        <div className="picker" ref={colorPickerRef}>
            <div className="picker__controls">
                <button className="picker__button" type="button" onClick={setDefault}>Clear</button>
                <button className="picker__button" type="button" onClick={() => {
                    onClose();
                }}>Close</button>
            </div>
            <HexColorPicker color={color} onChange={onChange} />
            <div className="picker__current-color" style={{ backgroundColor: `${bgColor}`, color: `${textColor}` }}>
                Text...
            </div>
            <div className="picker__swatches">
                {presetColors.map((presetColor) => (
                    <button
                        key={presetColor}
                        className="picker__swatch picker__button"
                        style={{ background: presetColor }}
                        onClick={() => onChange(presetColor)}
                        type="button"
                    />
                ))}
            </div>
        </div>
    );
};
